import { BUTTON_SIZES, DestructiveButton } from 'ui/button';
import { MODAL_SIZES, MODAL_VARIANTS, Modal, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';
import { useModalContext, ModalType, useCampaignContext } from '../../context';
import { BoldText } from '../../styles';
import { useAbortCampaign } from './useAbortCampaign';

export const ABORT_CAMPAIGN_MODAL_TEST_ID = 'abort-campaign-modal';
export const ABORT_CAMPAIGN_BUTTON_TEST_ID = 'abort-campaign-button';

export const AbortCampaignModal = () => {
  const { closeModal } = useModalContext();
  const { isLoading, abortCampaign } = useAbortCampaign();
  const {
    campaign: { name },
  } = useCampaignContext();

  return (
    <Modal
      withPortal
      isModalOpen={true}
      onClose={() => closeModal(ModalType.AbortCampaignModal)}
      id={ABORT_CAMPAIGN_MODAL_TEST_ID}
      data-test={ABORT_CAMPAIGN_MODAL_TEST_ID}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.DELETE}
    >
      <ModalHeader>Abort campaign?</ModalHeader>
      <ModalBody>
        Are you sure you want to abort <BoldText>{name}</BoldText>? This will stop messages from
        continuing sending.
      </ModalBody>
      <ModalFooter>
        <DestructiveButton
          data-test={ABORT_CAMPAIGN_BUTTON_TEST_ID}
          onClick={abortCampaign}
          isLoading={isLoading}
          size={BUTTON_SIZES.LARGE}
        >
          Abort campaign
        </DestructiveButton>
      </ModalFooter>
    </Modal>
  );
};
